//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class JobUrlConstants
{
	public static jobGuidVariable: string = `$jobGuid`;
	public static commandJobGuidVariable: string = `$commandJobGuid`;
	public static domainEventTypeVariable: string = `$domainEventType`;
	public static getJobUrlTemplate: string = `/api/Jobs/$jobGuid`;
	public static getRelatedDomainEventJobUrlTemplate: string = `/api/Jobs/GetRelatedDomainEventJob?commandJobGuid=$commandJobGuid&type=$domainEventType`;
}
